import React from 'react';

const LineHourglassSvg = ({ size = 12 }: { size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M3.5 1.5H4M4 1.5H8M4 1.5V3.5L6 6M8 1.5H8.5M8 1.5V3.5L6 6M3.5 10.5H4M4 10.5H8M4 10.5V8.5L6 6M8 10.5H8.5M8 10.5V8.5L6 6" />
  </svg>
);

export default LineHourglassSvg;
